// src/data/lawyers.js
// 변호사 프로필 데이터. slug 기반 조회.

// 랜딩 ExpertCredibility 섹션에서 카드로 노출되는 핵심 포인트 (3개)
// 상세 정보는 /lawyer/:slug 페이지로 이동해 확인
export const lawyersData = [
  {
    slug: 'kim-yongbum',
    landingHighlights: [
      '치과의사 · 변호사 이중 면허',
      '대한변협 의료법 · 형사법 전문',
      '인보사 · 맘모톰 · 앨러간 등 대형 의료사건 수행',
    ],
    landingTagline: '의학적 판단과 법적 절차를 한 사람이 동시에 수행합니다.',
    landingNarrative:
      '치과의사 면허를 가진 변호사로, 임상 현장의 판단과 법적 절차를 직접 수행합니다. 인보사·맘모톰·앨러간 유방보형물 등 사회적으로 문제가 된 다수의 의료 사건을 대리하며, 대한변협 의료법·형사법 이중 전문 변호사로 인증받았습니다.',
    name: '김용범',
    role: '파트너변호사 · 치과의사',
    photo: 'https://cdn.imweb.me/thumbnail/20220705/2ea73e6eeefa6.png',
    photoAlt: '김용범 파트너변호사 · 치과의사',
    contact: {
      tel: '02-538-5886',
      fax: '02-538-5887',
      email: 'ybkim@ohkimslaw.com',
    },
    summary:
      '김용범 변호사는 법무법인 오킴스의 파트너변호사로, 다수의 제약회사·바이오벤처·의료기기회사·병의원을 대리해 송무 및 고난이도 기업자문(M&A, 투자계약, 라이센싱)을 제공합니다. 의료인 출신 변호사로서 인보사·맘모톰·앨러간 유방보형물·산후조리원 영아 사망·투명치과 먹튀 사건 등 사회적으로 문제가 된 다수의 의료 관련 사건을 수행하며 사회적 역할을 다하고 있습니다.',
    credentials: [
      { label: '대한변호사협회 인증 의료법 전문 변호사' },
      { label: '대한변호사협회 인증 형사법 전문 변호사' },
      { label: '치과의사 면허 · 변리사 자격' },
      { label: '대한치과의사협회 · 서울시치과의사회 고문변호사' },
    ],
    career: [
      '2017~ 법무법인 오킴스',
      '2016 ㈜메가젠임플란트 전략기획실',
      '2014 ㈜동아쏘시오홀딩스 법무실',
    ],
    practiceAreas: [
      '기업법무 및 기업금융',
      '기업지배구조',
      '기업인수합병(M&A)',
      '스타트업',
      '제약·바이오 기술 라이센싱 계약',
      '의료분쟁',
      '의약품 및 의료기기 제조물책임 소송',
      '국민건강보험 및 민간 보험',
      '디지털헬스케어',
      '이커머스(E-commerce)',
      'ICT',
    ],
    notableCases: {
      '기업법무 및 기업금융': [
        '2021 상장 바이오벤처 S社 주주간 주식소유권 분쟁 자문',
        '2021 해외 바이오벤처 G社 SAFE 관련 자문',
        '2021 글로벌바이오 투자회사 M社 해외 바이오벤처 K社 기업실사 및 투자계약 자문',
        '2021 상장 바이오벤처 C社 최대주주변경 공시규정 자문',
        '2021 글로벌바이오 투자회사 M社 PEF설립 자문',
        '2020 상장 바이오벤처 S社 스톡옵션 관련 소송 수행',
        '2020 녹십자헬스케어 A스타트업 투자 계약 자문',
        '2020 주식회사 신테카바이오 정관·내규 개정 자문',
        '2019 조영제 개발 바이오벤처 M社 투자계약 자문',
        '2017 ㈜메가젠임플란트 스위스 스트라우만 社 전환사채 자문',
      ],
      '기업인수합병 및 지배구조': [
        '2021 상장 바이오벤처 주요주주 주식 매각 자문',
        '2021 바이오벤처 B社 피인수 자문',
        '2021 임상시험대행회사 A社 해외 바이오벤처 인수 자문',
        '2019 상장 제약회사 G사 국내 디지털헬스케어 스타트업 인수 자문',
        '2018 ㈜메가젠임플란트 EBI 임플란트 인수 기업실사 및 경영권인수계약 자문',
        '2018 OBRA Creative 악어컴퍼니 경영권·주식인수계약 자문',
        '2016 ㈜메가젠임플란트 신주발행금지 가처분을 통한 경영권 방어 (대구지법)',
      ],
      '제약·바이오·의료기기/기술라이센싱': [
        '㈜레이 해외 임상시험 계약 자문',
        '㈜녹십자헬스케어 의료법·약사법 자문 다수',
        '㈜녹십자웰빙 건강기능식품 소분 관련 규제샌드박스 자문',
        '상장 제약회사 D社 광고·판매업무정지처분 관련 식약처 대응',
        '안국약품㈜ 영업비밀 유출 손해배상청구 사건',
        '넥시온바이오텍 라이센싱 계약 자문 (Ipsen社)',
        '바이오벤처 T社 미국 Theracyte Inc. license and commercialization agreement 자문',
      ],
    },
    activities: [
      '2020~ 대한치과의사협회 고문변호사',
      '2020~ 서울시치과의사회 고문변호사',
      '2020~ 대한치과교정학회 자문변호사',
      '2019~ 강남문화재단 감사',
      '2019~ 서울바이오허브 자문위원',
      '2019~ 대한외과의사회 협력 변호사',
      '2019~ 헬스케어중심 4차산업혁명 포럼(HIRF) 임원',
      '2018~ 대한치과보존학회 법제위원',
      '2018~ 자연치아살리기운동본부 법제이사',
      '2008~2009 대한공중보건의사협의회 회장 (치과)',
    ],
    lectures: [
      '2020 SIDEX "닥터스 리걸마인드" 강의',
      '2020 YESDEX "치과의사 위기탈출 매뉴얼" 강의',
      '2019 "맘모톰 절제술 관련 소송의 쟁점과 전략" 세미나 발표 (대한외과의사회)',
      '2019 경상북도 치과의사회 보수교육 "병원에서의 의료분쟁" 강의',
      '2018 덴탈빈 심포지엄 "임플란트 의료분쟁의 예방 및 대응방법" 강의',
      '2015 저서: 잘나가는 병원을 위한 필수법지식 (매일경제신문사)',
    ],
    education: [
      '2014 고려대학교 법학전문대학원 법학전문석사',
      '2006 연세대학교 치의학과 학사',
      '1999 공주한일고등학교',
    ],
    certifications: [
      '한국변호사 (변호사시험 제3회)',
      '변리사 (특허청, 2014)',
      '치과의사 (보건복지부, 2006)',
      '한국프로야구 공인선수대리인 (KPBPA, 2018)',
      '대한변호사협회 인증 의료법 전문 변호사',
      '대한변호사협회 인증 형사법 전문 변호사',
    ],
    languages: ['한국어', '영어'],
  },
  {
    slug: 'cho-jinseok',
    name: '조진석',
    role: '구성원변호사 · 의사 · 의학박사과정 수료',
    photo: 'https://cdn.imweb.me/thumbnail/20230104/7f442bad2a92f.png',
    photoAlt: '조진석 구성원변호사 · 의사',
    contact: {
      tel: '02-538-5886',
      fax: '02-538-5887',
      email: 'jscho@ohkimslaw.com',
    },
    landingTagline: '의사로 진료하던 사람이, 그대로 변호사가 되어 의료분쟁을 다룹니다.',
    landingNarrative:
      '서울아산병원 등에서 의사로 근무한 후 변호사 자격을 취득해, 의료민사·형사·행정 전 영역에서 13년간 200건 이상의 의료사건을 직접 수행했습니다. 서울아산병원 법무팀 원내변호사로 6년간 근무하며 대형 종합병원의 분쟁 대응 메커니즘을 내부에서 운용했고, 한국의료분쟁조정중재원 비상임감정위원으로도 활동 중입니다.',
    landingHighlights: [
      '의사·변호사·의학박사과정 수료 · 보건의료헬스케어 총괄',
      '서울아산병원 법무팀 6년 · 대학병원·종합병원 다수 대리',
      '한국의료분쟁조정중재원 비상임감정위원',
    ],
    summary:
      '조진석 변호사는 의사면허를 보유한 의료·행정전문변호사로, 2007년 의사면허를 취득한 뒤 서울아산병원, 건국대학교 충주병원, 가천대 부속 동인천길병원 등에서 의사로 근무했습니다. 2013년 변호사 자격 취득 후 법무법인 세승 변호사 및 서울아산병원 법무팀 원내변호사로 근무했으며, 현재 법무법인 오킴스의 보건의료헬스케어 총괄 구성원변호사로서 의료민사·의료행정·의료형사 및 의료기관(의사단체·학회) 자문을 수행합니다. 임의비급여 환수·과징금, 혈우병치료제·항암제 요양급여 삭감, 약제비환수, 보험사기방지법 위반, 연명의료결정법 위반, 응급의료법 위반, 실손보험사 대응 사건과 함께 소아청소년과 환아 사망, 신경외과 사지마비, 정신질환자 자살, 응급실 내원 환자 사망 등 다수의 중대 의료사건을 대리해 왔습니다.',
    credentials: [
      { label: '의사 · 변호사 이중 면허' },
      { label: '의학박사과정 수료 (울산대학교)' },
      { label: '서울아산병원 법무팀 원내변호사 (2017~2023)' },
      { label: '한국의료분쟁조정중재원 비상임감정위원' },
    ],
    career: [
      '2023~ 법무법인 오킴스 구성원변호사',
      '2017~2023 법무법인 세승 구성원변호사',
      '2017~2023 서울아산병원 법무팀 원내변호사',
      '2014 서울대학교병원 의료고위과정(AHP) 수료',
      '2013 법무법인 세승 소속변호사',
      '2011 법제처 · 건강보험심사평가원 실무수습',
      '2008 울산의대 서울아산병원 수련의',
      '2007 일반의사 근무 (건국대 충주병원 · 가천대 동인천길병원 등)',
    ],
    practiceAreas: [
      '의료민사 (손해배상)',
      '의료형사 (업무상과실치사·치상, 의료법 위반)',
      '의료행정 (요양급여 삭감·환수, 면허·자격정지)',
      '의료분쟁 조정·중재',
      '의료기관·의사단체·학회 자문',
      '보건의료 정책·규제 자문',
      '응급의료법 · 연명의료결정법',
      '보험사기방지법 · 실손보험사 대응',
    ],
    notableCases: {
      '의료 민사 손해배상 — 병원·의료기관 대리': [
        '2013 Y대학교병원·G대학교병원 임의비급여 환수 관련 민사 소송',
        '2014 K대학교병원 신경외과적 응급환자 진료 관련 손해배상(의) 소송',
        '2014 A병원 대장암 수술 후 배뇨장애 발생 환자 손해배상(의) 소송',
        '2014 J대학교병원 정형외과 수술 후 환자 사망 사건 손해배상(의) 소송',
        '2015 성형 수술 후 부작용 호소 환자 관련 손해배상(의) 소송',
        '2016 I대학교병원 외상 환자 사망 사건 손해배상(의) 소송',
        '2016 K병원 외과 수술 후 환자 사망 사건 손해배상(의) 소송',
        '2016 J병원 통증 시술 후 혈종 발생 사건 손해배상(의) 소송',
        '2017 A병원 안과 시술 관련 실손보험사 손해배상 청구 소송',
        '2017 K대학교병원 소아 심장 시술 후 환아 사망 사건 민·형사 소송',
        '2017 J대학교병원 소아 혈액질환 진단 관련 손해배상(의) 소송',
        '2017 J대학교병원 응급실 내원 소아 외상 환자 손해배상(의) 소송',
        '2017 N병원 소화기내시경 환자 사망 사건 손해배상(의) 소송',
        '2017 K병원 응급실 내원 호흡곤란 환자 사망 손해배상(의) 소송',
        '2017 M병원 척추 수술 후 신경 마비 사건 손해배상(의) 소송',
        '2018 C대학교병원 산부인과 수술 후 장 천공 발생 손해배상(의) 소송',
        '2018 건강검진 내시경 시술 중 호흡곤란 발생 환자 손해배상(의) 소송',
        '2019 K대학병원 산모 사망 사건 손해배상(의) 소송',
        '2019 맘모톰 관련 실손보험사 구상금 청구 민사 소송',
        '2019 J병원 관상동맥질환 환자 사망 손해배상(의) 소송',
        '2019 S병원 독감 치료제 투여 소아 환각 손해배상(의) 소송',
        '2019 B안과 백내장 수술 관련 실손보험사 구상금 청구 민사 소송',
        '2020 피부과 시술 후 캘로이드 병변 발생 손해배상(의) 소송',
        '2020 산부인과 시술 후 임산부 사망 손해배상(의) 소송',
        '2021 H병원 전신 마취 환자 호흡곤란 발생 손해배상(의) 소송',
        '2021 J대학교병원 소화기계 암 진단 지연 손해배상(의) 소송',
        '2021 H요양병원 욕창 발생 환자 사망 손해배상(의) 소송',
        '2021 K대학교병원 정신건강의학과 입원 환자 자살 손해배상(의) 소송',
        '2021 M정신건강의학과 외래 환자 자살 손해배상(의) 소송',
        '2022 S대학교병원 정신질환자 오진 주장 손해배상 청구 소송',
        '2023 G병원 신경외과 뇌동맥류 시술 후 환자 사망 손해배상(의) 소송',
        '2023 K대학교병원 응급실 내원 소아 환자 사망 손해배상(의) 소송',
        '2023 D병원 장 폐색 환자 손해배상(의) 소송',
        '2024 G병원 정형외과 수술 후 환자 사지마비 발생 손해배상(의) 소송',
        '2024 M치과 임플란트 시술 후 환자 사망 손해배상(의) 소송',
        '2024 H산부인과 분만 후 뇌성 마비 발생 손해배상(의) 소송',
        '2024 U병원 심장 스텐트 시술 후 환자 사망 손해배상(의) 소송',
        '2025 K대학교병원 췌장암 진단 및 항암화학요법 시행 손해배상(의) 소송',
        '2025 M성형외과 안면 성형수술 후 불만족 손해배상(의) 소송',
        '2025 A병원 외과 수술 후 환자 사망 손해배상(의) 소송',
        '2025 Y마취통증의학과 통증시술 후 환자 사지마비 손해배상(의) 소송',
        '2025 D병원 소아청소년과 입원 환자 진단 관련 손해배상(의) 소송',
        '2025 M성형외과 수술 중 호흡곤란 발생 환자 손해배상(의) 소송',
        '2025 A병원 신경외과 수술 후 사지마비 발생 환자 손해배상(의) 소송',
      ],
      '의료 민사 손해배상 — 환자 대리': [
        '2014 여성질환 수술 후 환자 사지마비 손해배상(의) 소송',
        '2015 소아 환자 약물 과다 투여 사건 손해배상(의) 소송',
        '2015 신경차단술 후 하지 마비 발생 환자 손해배상(의) 소송',
        '2016 성형수술 후 부작용 발생 환자 손해배상(의) 소송',
        '2019 척추 시술 후 혈종 진단 지연으로 인한 하지 마비 손해배상(의) 소송',
        '2019 각막궤양 진단 지연으로 인한 실명 손해배상(의) 소송',
        '2023 전신 마취 정형외과 수술 후 환자 사망 손해배상(의) 소송',
        '2023 부위 마취 하 정형외과 수술 후 환자 사지마비 발생 손해배상(의) 소송',
      ],
      '의료 형사 변호 (업무상과실치사·치상, 의료법 위반 등)': [
        '2015 비뇨기 항암 치료 후 환자 사망 업무상과실치사 피의자 변호',
        '2015 의료인 개인정보보호법 위반 피의자 변호',
        '2015 전신마취 환자 사망 업무상과실치사 피의자 변호',
        '2016 양악 수술 후 환자 사망 형사 사건',
        '2017 A병원 흉부외과 환자 사망 업무상과실치사 피의자 변호',
        '2017 K대학교병원 응급실 내원 소아 환자 사망 업무상과실치사 피의자 변호',
        '2018 비뇨의학과 남성 보형물 의료법 위반 피의자 변호',
        '2018 K대학교병원 외과 수술 후 환자 사망 업무상과실치사 피의자 변호',
        '2018 맘모톰 관련 실손보험사 고발 사건 피의자 변호',
        '2019 외래진료실 성추행 피의 사건 피의자 변호',
        '2019 A병원 무면허의료행위 의료법 위반 피의자 변호',
        '2020 F병원 무면허의료행위 의료법 위반 피의자 변호',
        '2020 A병원 신생아 사망 업무상과실치사 피의자 변호',
        '2020 K대학교병원 무면허의료행위 의료법 위반 피의자 변호',
        '2020 K대학교병원 정형외과 수술 후 환자 사망 업무상과실치사 피의자 변호',
        '2020 K대학교병원 말기 암 환자 연명의료결정법 위반 피의자 변호',
        '2020 D병원 무면허의료행위 의료법 위반 피의자 변호',
        '2021 J대학교병원 사망진단서 관련 의료법 위반 형사 공판 피고인 변호',
        '2021 산부인과 진정 마취 부작용 업무상과실치상 피의자 변호',
        '2021 K대학교병원 신장 이식 수술 후 저산소성 뇌손상 업무상과실치상 피의자 변호',
        '2021 A병원 전신 마취 후 회복실 심정지 업무상과실치사 피의자 변호',
        '2021 D대학교병원 고령 욕창 환자 사망 업무상과실치사 피의자 변호',
        '2021 K대학교병원 하지 혈관질환 환자 시술 후 사망 업무상과실치사 피의자 변호',
        '2022 K대학교병원 응급실 대동맥 박리 의심 환자 사망 업무상과실치사 피의자 변호',
        '2022 K대학교병원 심장 시술 환자 사망 업무상과실치사 피의자 변호',
        '2022 A병원 소화기 내시경 후 환자 사망 업무상과실치사 피의자 변호',
        '2022 S병원 방사선치료 관련 업무상과실치상 피의자 변호',
        '2023 U병원 무면허의료행위 의료법 위반 피의자 변호',
        '2023 D병원 무면허의료행위 의료법 위반 피의자 변호',
        '2023 K대학교병원 위암 수술 후 환자 사망 업무상과실치사 피의자 변호',
        '2023 F병원 응급실 수용 곤란 응급의료법 위반 피의자 변호',
        '2023 A병원 소화기 시술 후 환자 사망 업무상과실치사 피의자 변호',
        '2023 G대학교병원 심장 시술 후 환자 사망 업무상과실치사 피의자 변호',
        '2024 요양병원 욕창 발생 업무상과실치사 피의자 변호',
        '2024 T성형외과 유방 수술 후 조직 괴사 업무상과실치상 형사 공판 피고인 변호',
        '2024 S치과 무면허의료행위 의료법 위반 피의자 변호',
        '2024 A영상의학과 의료광고 관련 의료법 위반 피의자 변호',
        '2024 E대학교병원 정형외과 수술 후 환자 사망 업무상과실치사 피의자 변호',
        '2024 Y성형외과 전신 마취 후 악성 고열 사망 업무상과실치사 피의자 변호',
        '2024 C이비인후과 무면허의료행위 의료법 위반 피의자 변호',
        '2024 Y대학교병원 신경외과 입원 환자 사망 업무상과실치사 피의자 변호',
        '2024 Y정신건강의학과 환자 처방 의료법 위반 피의자 변호',
        '2024 S성형외과 무면허의료행위 의료법 위반 피의자 변호',
        '2025 R치과 진정 마취 환자 사망 업무상과실치사 피의자 변호',
        '2025 M병원 산부인과 시술 후 환자 사망 업무상과실치사 형사 공판 피고인 변호',
        '2025 I성형외과 성형 수술 후 수술 부위 감염 업무상과실치상 피의자 변호',
        '2025 E산부인과 분만 후 지혈 처치 관련 업무상과실치상 피의자 변호',
        '2025 H병원 중환자실 입원 환자 기관절개술 업무상과실치사 피의자 변호',
        '2025 T성형외과 유방 수술 후 조직 괴사 업무상과실치상 피의자 변호',
      ],
      '의료 행정 소송': [
        '2013 공중보건의사 복무연장처분 취소 행정 소송 (의사 대리)',
        '2015 A대학교병원 혈우병 치료제 비용 조정 처분 행정 소송',
        '2016 혈액투석 관련 요양급여비용 심사조정 행정 소송',
        '2017 허위 처방 관련 의사 면허 자격정지 행정 소송',
        '2018 A대학교병원 혈우병 치료제 비용 조정 처분 행정 소송',
        '2019 항암제 요양급여비용 조정 처분 행정 소송',
        '2022 대리 처방 관련 의사 면허자격 정지 처분 행정 소송',
        '2023 F병원 응급실 수용 곤란 시정명령 관련 행정 소송',
      ],
      '의료분쟁 조정·합의 및 기타': [
        '2016 정형외과 의료기관 동업정산 사건',
        '2016 K대학교병원 의료진 위협 환자 보호자 접근금지 가처분 신청',
        '2017 퇴직 의사 퇴직금 등 급여 미지급 민사 소송',
        '2017 S아동병원 환아 사망 한국의료분쟁조정중재원 조정',
        '2018 H병원 시술 후 장애 발생 한국의료분쟁조정중재원 조정',
        '2019 백내장 시술 관련 안과 의료분쟁 합의',
        '2019 S제약회사 약물 부작용 손해배상(기) 소송 (제약회사 대리)',
        '2022 COVID-19 백신 접종 후 사망 사건 의료분쟁 합의',
        '2023 H치과 외래 내원 환자 사망 한국의료분쟁조정중재원 조정',
        '2023 U소아청소년과 환자 진단 지연 한국의료분쟁조정중재원 조정',
        '2023 F병원 의료분쟁 관련 시위집회 금지 가처분 신청',
        '2024 L치과 근거 없는 의료행위 한국의료분쟁조정중재원 조정 (환자 대리)',
        '2024 정부의 의과대학 입학정원 증원 관련 전공의 지원',
        '2024 Y피부과 아나필락시스 환자 사망 의료분쟁 합의',
        '2025 G대학교병원 의료분쟁 관련 시위집회 금지 가처분 신청',
        '2025 O치과 진정 마취 환자 사망 의료분쟁 합의',
      ],
    },
    activities: [
      '2025~ 코로나19 예방접종 피해보상 자문위원',
      '2024~ 국립정신건강센터 임상시험심사위원회 위원',
      '2022~ 국립정신건강센터 입원적합성심사위원',
      '2021~ 대한마취통증의학회 법률상담변호사',
      '2020~ 한국의료분쟁조정중재원 비상임감정위원',
    ],
    lectures: [
      '대한마취통증의학회 · 대한신경외과학회 · 대한신경정신의학회 등 의료 학회 다수 강의',
      '의과대학 · 종합병원 의료법 및 의료분쟁 대응 강의 다수',
    ],
    education: [
      '2020 울산대학교 일반대학원 의학박사과정 수료',
      '2017 울산대학교 일반대학원 의학석사',
      '2013 고려대학교 법학전문대학원 법학전문석사',
      '2007 울산대학교 의과대학 의학사',
    ],
    certifications: ['한국변호사 (변호사시험 제2회)', '의사 (보건복지부, 2007)'],
    languages: ['한국어'],
  },
];

export function getLawyerBySlug(slug) {
  return lawyersData.find((l) => l.slug === slug);
}
